// test2905
(2905 && 0);
